import { loggerInit } from '@globalwebindex/platform2-react-ui-components/src/ui/utils';
import { APPLICATION_NAME } from '../constants';

const logger = loggerInit(APPLICATION_NAME);
export default logger;
